export default "__VITE_ASSET__705ebdb2__"